import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.css', '../terms-and-conditions-dialog/terms-and-conditions-dialog.component.css']
})
export class PrivacyPolicyComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<PrivacyPolicyComponent>
  ) {
    dialogRef.disableClose = true;
   }
  ngOnInit(): void {
  }

  keyEscape(event: any) {
    // console.log(event)
    if(event.key === 'Escape') {
      this.dialogRef.close();
    }

    if(event.keyCode === 13) {
      document.getElementById('AgreeTerms')?.focus()
    }
  }

  leftArrowClick(): void {
    this.dialogRef.close();
  }

}
